import type { TNacionalidade } from '@/types/cliente'

/**
 * A API retorna as nacionalidades traduzidas e ordenadas, com a primeira do array
 * definida como a nacionalidade principal (default) do país. Usada tanto no fluxo
 * do Brasil quanto no do Chile para pré-preencher o cadastro de compradores.
 */
export const getNacionalidadePrincipalId = (nacionalidades: TNacionalidade[] | undefined): string =>
  nacionalidades?.[0]?.id ?? ''
